/**
 * LocalStorage Keys Constants
 *
 * Centralized definition of localStorage keys used throughout the application.
 * This prevents typos and makes it easier to maintain and update key names.
 */

export const LOCAL_STORAGE_KEYS = {
  /** The currently selected AI model for document processing */
  SELECTED_MODEL: 'selectedModel',
  /** The currently selected industry for document processing */
  SELECTED_INDUSTRY: 'selectedIndustry',
  /** Path to redirect to after successful login (must be a safe relative path) */
  REDIRECT_AFTER_LOGIN: 'redirect_after_login',
} as const;

/**
 * Returns true only for relative paths that are safe for post-login redirect.
 * Rejects protocol-relative (//) or absolute URLs to prevent open redirects.
 */
export function isSafeRelativeRedirect(path: string): boolean {
  return (
    typeof path === 'string' && path.length > 0 && path.startsWith('/') && !path.startsWith('//')
  );
}

/**
 * Type for localStorage keys to ensure type safety
 */
export type LocalStorageKey = (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS];
